import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate, isWithin} from '../DateUtil'
import LineItem from './LineItem'

export default function LineItemRecur (props, recur) {
  const lineItem = LineItem(props)

  const self = {
    recur: recur,
    isRecurring: true,
    isPermanent: !props.max_payments,
    payments: recur && recur.payments || [],
    subscriptionExpireAt: props.subscription_expire_at
  }

  const status = recur && recur.status

  self.needsPayment = status != 'ACTIVE' &&
  (self.isPermanent || self.payments.length + 1 < props.max_payments) &&
  new Date(props.subscription_expire_at) < new Date()

  self.matches = (enrollment) => {
    const matchesSelf = lineItem.matches(enrollment)
    const matchesSku = lineItem.sku == enrollment.sku
    const matchesRecurs = self.payments.find((payment) => {
      return payment.orderId == enrollment.shopify_order_id
    })
    return matchesSelf || (matchesSku && !!matchesRecurs)
  }

  // shopper#646 : add payments from other recurring line items (Restart Subscription)
  self.addPayments = (recurPayments) => {
    self.payments.push(...recurPayments)
  }

  return Object.assign({}, lineItem, self)
}
